<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppCall',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 12</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="企业详情-联系方式-解锁"
          transform="translate(-274.000000, -746.000000)"
          fill-rule="nonzero"
          stroke="#242934"
        >
          <g id="编组-20" transform="translate(242.000000, 565.000000)">
            <g id="编组-5" transform="translate(0.000000, 160.000000)">
              <g id="编组-12" transform="translate(32.000000, 21.000000)">
                <path
                  id="路径"
                  d="M4.34376846,1.5112107 C4.62477068,1.48304266 4.83681673,1.529413 4.99756913,1.59763392 C6.09775768,2.90971367 6.8822862,4.51892394 6.9368557,5.11428714 C6.79344978,5.80888179 6.4842566,6.05263495 6.20712364,6.24668024 C6.00566431,6.53249387 6.2352548,6.86679005 7.37848767,8.03789306 L7.37848767,8.03789306 L7.96244518,8.63498473 C9.09954664,9.75815622 9.44606017,9.97323419 9.53842796,9.98924806 C9.94379549,9.51192992 10.2044168,9.21756118 10.6395242,9.10755669 C11.5022233,9.16834358 13.0935774,9.9739722 14.0151548,10.6123022 C14.152676,10.6990732 14.3546318,10.871457 14.450836,11.2022788 C14.5026825,11.3805657 14.5259122,11.6164343 14.45808,11.9322569 C14.3440401,12.4445544 13.9681916,13.1197505 13.4535255,13.6417826 C12.9950647,14.106805 12.4340433,14.4380337 11.8785215,14.4906279 C10.1887178,14.5647512 7.88145128,13.3196007 5.64175758,11.0560164 L5.64175758,11.0560164 L4.86103033,10.2720973 C2.61239881,8.00289593 1.40724675,5.69840336 1.50617292,4.11943531 C1.54563554,3.52386967 1.91660275,2.92330508 2.44520161,2.4488781 C3.03229512,1.92195113 3.79098274,1.56561805 4.34376846,1.5112107 Z"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
